export const environment = {
    production: true,
    environmentName: 'test',
    defaultGuid: '00000000-0000-0000-0000-000000000000',
    msalConfig: {
        auth: {
            clientId: 'b01a306e-a182-4bb5-a3a0-de826b186faa',
        },
    },
    apiConfig: {
        scopes: ['https://qualicoatworkspace.onmicrosoft.com/qualicoat-api-test/all.readwrite'],
        apiBaseUrl: 'https://api.test.qualicoat.net',
        apiUri: '/api/v1',
        publicApiUri: '/public-api/v1',
        odataUri: '/odata',
        notificationsUri: '/notifications',
        eventsUri: '/events',
    },
    b2cPolicies: {
        names: {
            signIn: 'b2c_1_signin_v1',
            signUp: 'b2c_1_signup_v1',
            resetPassword: 'b2c_1_password_reset_v1',
        },
        authorities: {
            signIn: {
                authority: 'https://qualicoatworkspace.b2clogin.com/qualicoatworkspace.onmicrosoft.com/b2c_1_signin_v1',
            },
            signUp: {
                authority: 'https://qualicoatworkspace.b2clogin.com/qualicoatworkspace.onmicrosoft.com/b2c_1_signup_v1',
            },
            resetPassword: {
                authority: 'https://qualicoatworkspace.b2clogin.com/qualicoatworkspace.onmicrosoft.com/b2c_1_password_reset_v1',
            },
        },
        authorityDomain: 'qualicoatworkspace.b2clogin.com',
    },
};
